/* RUN-SS-ENDORSE-01: click-to-load video facades. No Instagram/TikTok/YouTube script loads until the viewer taps play. */
(function () {
  if (window.__pgFacade) return; window.__pgFacade = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.pg-facade[data-src]');
    if (!b) return;
    e.preventDefault();
    var f = document.createElement('iframe');
    f.src = b.getAttribute('data-src');
    f.title = b.getAttribute('aria-label') || 'Video';
    f.allow = 'autoplay; encrypted-media; picture-in-picture; clipboard-write';
    f.allowFullscreen = true;
    f.loading = 'eager';
    b.removeAttribute('data-src');
    b.appendChild(f);
    var p = b.querySelector('.pg-play'); if (p) p.remove();
  });
})();
